module.exports = __webpack_public_path__ + "img/maskgroup2.a260f686.png";